import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isOpen", "theme", "portalClassName", "portalRef", "disableScroll", "portalProps", "onClose", "closeOptions"];
import React, { forwardRef, useRef } from 'react';
import { cnBem, combineRefs } from '@carnica/utils';
import { DIMENSION_TYPE, useBlockScroll, useBreakpoints, useKeys } from '@carnica/utils/hooks';
import { EKeyCodes } from '@carnica/utils/types';
import { AnimatePresence, motion } from 'framer-motion';
import { ThemedPortal } from "../../modules/ThemedPortal";
import { BottomSheet } from "../../modules/BottomSheet";
import styles from "./styles.pcss";
import { ModalContent } from "./ModalContent";
var cnModal = cnBem('modal', styles);
var defaultCloseOptions = {
  overlay: true,
  button: true,
  escape: true
};
export var Modal = /*#__PURE__*/forwardRef(function (props, ref) {
  var isOpen = props.isOpen,
    theme = props.theme,
    portalClassName = props.portalClassName,
    portalRef = props.portalRef,
    _props$disableScroll = props.disableScroll,
    disableScroll = _props$disableScroll === void 0 ? true : _props$disableScroll,
    portalProps = props.portalProps,
    onClose = props.onClose,
    _props$closeOptions = props.closeOptions,
    closeOptions = _props$closeOptions === void 0 ? defaultCloseOptions : _props$closeOptions,
    otherProps = _objectWithoutProperties(props, _excluded);
  var containerRef = useRef(null);
  var _useBreakpoints = useBreakpoints(),
    _useBreakpoints2 = _slicedToArray(_useBreakpoints, 1),
    dimension = _useBreakpoints2[0];
  useKeys(_defineProperty({}, EKeyCodes.Escape, function (e) {
    return isOpen && closeOptions.escape && (onClose === null || onClose === void 0 ? void 0 : onClose(e));
  }));
  useBlockScroll(disableScroll && isOpen);
  var isMobile = dimension === DIMENSION_TYPE.MOBILE;

  // Необходимо для того чтобы не скакала модалка при открытии
  if (!dimension) {
    return null;
  }
  if (isMobile) {
    return /*#__PURE__*/React.createElement(BottomSheet, props, otherProps.children);
  }
  return /*#__PURE__*/React.createElement(AnimatePresence, {
    custom: isOpen,
    initial: false,
    mode: "wait"
  }, isOpen && /*#__PURE__*/React.createElement(ThemedPortal, _extends({}, portalProps || {}, {
    "aria-modal": true,
    className: cnModal(null, [portalClassName]),
    motion: true,
    ref: combineRefs([portalRef, containerRef]),
    role: "dialog",
    theme: theme
  }), /*#__PURE__*/React.createElement(motion.div, {
    animate: {
      opacity: 1
    },
    "aria-hidden": "true",
    className: cnModal('overlay'),
    exit: {
      opacity: 0
    },
    initial: {
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement(ModalContent, _extends({
    closeOptions: closeOptions,
    containerRef: containerRef,
    isOpen: isOpen,
    onClose: onClose,
    ref: ref
  }, otherProps))));
});